

import {defineComponent, PropType} from "vue";


export const IconNameObj = {
  "Apps": "\ue900",
  "Arrowhead-down": "\ue901",
  "Arrowhead-left": "\ue902",
  "Arrowhead-right": "\ue903",
  "Arrowhead-up": "\ue904",
  "Back": "\ue905",
  "Bookmark": "\ue906",
  "Menu": "\ue907",
  "Calendar": "\ue908",
  "Chat": "\ue909",
  "Check": "\ue90a",
  "Close": "\ue90b",
  "Document": "\ue90c",
  "Download": "\ue90d",
  "Drop-down": "\ue90e",
  "Edit": "\ue90f",
  "Email": "\ue910",
  "Show": "\ue911",
  "Facebook": "\ue912",
  "Favorite": "\ue913",
  "Filter": "\ue914",
  "Full-screen-exit": "\ue915",
  "Full-screen": "\ue916",
  "Language": "\ue917",
  "History": "\ue918",
  "Home": "\ue919",
  "Image": "\ue91a",
  "Information": "\ue91b",
  "Instagram": "\ue91c",
  "Link-extern": "\ue91d",
  "Login": "\ue91e",
  "Link": "\ue91f",
  "Linkedin": "\ue920",
  "Location": "\ue921",
  "Maximize": "\ue922",
  "Microphone": "\ue923",
  "Minimize": "\ue924",
  "Minus": "\ue925",
  "Notification": "\ue926",
  "Options": "\ue927",
  "Pause": "\ue928",
  "Document-PDF": "\ue929",
  "Phone": "\ue92a",
  "Play": "\ue92b",
  "Plus": "\ue92c",
  "Reading-time": "\ue92d",
  "Refresh": "\ue92e",
  "Search": "\ue92f",
  "Settings": "\ue930",
  "Share": "\ue931",
  "Shopping-cart": "\ue932",
  "Support": "\ue933",
  "Twitter": "\ue934",
  "User": "\ue935",
  "Warning": "\ue936",
  "YouTube": "\ue937",
  "Yammer": "\ue938",
  "Close-small": "\ue939",
  "Check-small": "\ue93a",
  "Search-small": "\ue93b",
  "Plus-small": "\ue93c",
  "Home-small": "\ue93d",
  "Attach": "\ue93e",
  "Bar-chart": "\ue93f",
  "Configuration": "\ue940",
  "Copy": "\ue941",
  "Cut": "\ue942",
  "Document-success": "\ue943",
  "Error": "\ue944",
  "Folder-new": "\ue945",
  "Folder-open": "\ue946",
  "Folder": "\ue947",
  "Hide": "\ue948",
  "Hourglass": "\ue949",
  "Line-chart": "\ue94a",
  "Optimize": "\ue94b",
  "Paste": "\ue94c",
  "Plant": "\ue94d",
  "Question": "\ue94e",
  "Redo": "\ue94f",
  "Reset": "\ue950",
  "Save": "\ue951",
  "Skip-back": "\ue952",
  "Skip": "\ue953",
  "Sort-ascending": "\ue954",
  "Sort-descending": "\ue955",
  "Sort": "\ue956",
  "Stop": "\ue957",
  "Success": "\ue958",
  "Trash": "\ue959",
  "Undo": "\ue95a",
  "Zoom-in": "\ue95b",
  "Zoom-out": "\ue95c",
  "Acknowledge-events": "\ue95d",
  "Add-workorder": "\ue95e",
  "Arrow-double-left": "\ue95f",
  "Arrow-double-right": "\ue960",
  "Browse-all": "\ue961",
  "Close-big": "\ue962",
  "Configure": "\ue963",
  "Explore": "\ue964",
  "Interaction-click": "\ue965",
  "Interaction-touch": "\ue966",
  "Logout": "\ue967",
  "Monitor": "\ue968",
  "Navigation-left": "\ue969",
  "Navigation-right": "\ue96a",
  "Options-horizontal": "\ue96b",
  "Sort-down": "\ue96c",
  "Sort-up": "\ue96d",
  "Sort-up-down": "\ue96e",
  "Volume-loud": "\ue96f",
  "Volume-quiet": "\ue970",
  "Volume-mute": "\ue971",
  "Locked": "\ue972",
  "Unlocked": "\ue973",
  "Buildings": "\ue974",
  "Document-DOC": "\ue975",
  "Document-MP4": "\ue976",
  "Document-PPT": "\ue977",
  "Document-TXT": "\ue978",
  "Document-XLS": "\ue979",
  "QR-code": "\ue97a",
  "Pin": "\ue97b",
  "Pinned": "\ue97c",
  "Arrow-down": "\ue97d",
  "Arrow-left": "\ue97e",
  "Arrow-right": "\ue97f",
  "Arrow-up": "\ue980",
  "Resize": "\ue981",
  "Drag-drop": "\ue982",
  "Source-code": "\ue983",
  "Group-people": "\ue984",
  "Print": "\ue985",
  "Upload": "\ue986",
  "Social-feed": "\ue987",
  "Favorite_marked": "\ue988",
  "Bold": <div style={{fontWeight: 900}}>B</div>,
  "Italic": <div style={{fontStyle: "italic"}}>i</div>,
} as const

export type IconName = keyof typeof IconNameObj;

const textIcons = new Set(["Bold", "Italic"]) as Set<IconName>;

export default defineComponent({
  name: "Icon",
  props: {
    name: {
      type: String as PropType<IconName>,
      required: true
    }
  },
  render() {
    return (
      <span class={[
        'icon',
        textIcons.has(this.$props.name) ? 'icon--text' : ''
      ]}>
        {IconNameObj[this.$props.name]}
      </span>
    )
  }
})
